<div class="page-not-found-container">
  <div class="error-content">
    <div class="error-icon">
      <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" fill="#e74c3c"/>
      </svg>
    </div>
    
    <h1 class="error-title">404</h1>
    <h2 class="error-subtitle">Page Not Found</h2>
    <p class="error-message">
      Sorry, the page you are looking for doesn't exist or has been moved.
    </p>
    
    <div class="error-actions">
      <button class="btn btn-primary" (click)="goHome()">
        <i class="fas fa-home"></i>
        Go to Home
      </button>
      <button class="btn btn-secondary" (click)="goBack()">
        <i class="fas fa-arrow-left"></i>
        Go Back
      </button>
    </div>
  </div>
</div>
